import {t} from '@lingui/macro'
import {toast} from 'react-hot-toast'

import {UserModel} from '@/models/User'

export const successUpdateUser = (user: UserModel) =>
  toast.success(t`Your profile was updated successfully.`)
